(() => {
  'use strict';

  const loader = document.currentScript;
  if (!loader) return;

  const midaSrc = loader.dataset.midaSrc;

  function loadMida() {
    if (!midaSrc || document.querySelector('script[data-mida-deferred]')) return;

    const script = document.createElement('script');
    script.src = midaSrc;
    script.async = true;
    script.dataset.midaDeferred = '';
    document.head.appendChild(script);
  }

  function scheduleMida() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadMida, { timeout: 2500 });
    } else {
      window.setTimeout(loadMida, 1500);
    }
  }

  if (document.readyState === 'complete') {
    scheduleMida();
  } else {
    window.addEventListener('load', scheduleMida, { once: true });
  }
})();
